import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { wallMessages } from '../mock';

export default function WallSection() {
  return (
    <section id="mur" className="relative">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pb-20">
        <div className="rounded-[32px] bg-white border border-black/5 p-8 sm:p-12 overflow-hidden">
          <div className="grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
              <div className="text-[11px] tracking-[0.18em] uppercase font-medium text-neutral-500">Nouveau · Murs communautaires</div>
              <h2 className="mt-2 text-[clamp(1.8rem,3.6vw,3rem)] leading-[1.05] font-semibold tracking-tight text-[#1a1d1a]">
                Le <span className="serif-italic text-[#d97757]">Mur des Joies</span> & <br /> le <span className="serif-italic text-[#5a8268]">Mur de Yako</span>.
              </h2>
              <p className="mt-5 text-[15px] text-neutral-600 max-w-md">
                Chaque don avec un message rejoint un grand mur public. Une trace collective des bénédictions et des messages de soutien partagés à travers Fodindin.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Button className="btn-anim rounded-full bg-[#d97757] hover:bg-[#c66745] text-white h-11 px-5 text-[14px]">Mur des Joies <ArrowRight className="w-4 h-4 ml-1" /></Button>
                <Button className="btn-anim rounded-full bg-[#5a8268] hover:bg-[#4a6f57] text-white h-11 px-5 text-[14px]">Mur de Yako <ArrowRight className="w-4 h-4 ml-1" /></Button>
              </div>
            </div>
            <div className="lg:col-span-7">
              <div className="columns-1 sm:columns-2 gap-3 [column-fill:_balance]">
                {wallMessages.map((m) => {
                  const isYako = m.type === 'Yako';
                  return (
                    <div key={m.id} className={`mb-3 break-inside-avoid rounded-2xl border p-4 ${isYako ? 'bg-[#eaf1e7] border-[#5a8268]/15' : 'bg-[#fff3ec] border-[#d97757]/15'}`}>
                      <div className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: isYako ? '#5a8268' : '#d97757' }}>{m.type}</div>
                      <div className="mt-2 text-[14px] text-neutral-800 leading-relaxed">“{m.message}”</div>
                      <div className="mt-3 flex items-center justify-between text-[12px]">
                        <div className="font-medium text-neutral-700">{m.donor}</div>
                        <div className="font-semibold text-[#1a1d1a]">{m.amount}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
